<template> 
    <div class="article">
        <div class="article-content">

            <div class="article-title">{{ detail.title }}</div>
            <div class="article-tag" v-if="detail.publish_time">
                <div class="article-time">
                    <img src="@assets/article/icon_day.png" srcset="@assets/article/icon_day@2x.png 2x" alt="" />
                    {{ dayjs( detail.publish_time ).format('YYYY/MM/DD') }}
                </div>
            </div>

            <div class="article-html" v-html="detail.content_html"></div>
            

            <div class="article-footer">
                <div class="article-footer-left">
                    <div class="article-footer-title" v-if="detail.prev_article?.title">{{ lang.prevArticle }}</div>
                    <div class="article-footer-link" @click="handleClick(detail.prev_article)">{{ detail.prev_article?.title }}</div>
                </div>
                <div class="article-footer-right">
                    <div class="article-footer-title" v-if="detail.next_article?.title">{{ lang.nextArticle }}</div>
                    <div class="article-footer-link" @click="handleClick(detail.next_article)">{{ detail.next_article?.title }}</div>
                </div>
            </div>
        </div>
        
        <div>
            <Hot class="hot" />
        </div>
        
    </div>
</template>

<script setup>
    import dayjs from 'dayjs';
    import { onMounted, ref, watch } from 'vue';
    import { ArticleDetailAPI } from '@/api/common.js';
    import Hot from '@/views/news/components/hot.vue';
    import { useRouter, useRoute } from 'vue-router'
    const router = useRouter()
    const route = useRoute();

    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.article
    }) 

    const articleId = ref(route.params.id);

    const detail = ref({
        title: '',
        publish_time: '',
        content_html: ''
    });

    // 获取文章详情
    const getDetail = () => {
        ArticleDetailAPI({ id: articleId.value }).then(res => {
            detail.value = res;
        });
    }

    // 点击跳转
    const handleClick = (item) => {
        // window.open(`/article?id=${item.id}`, '_blank')
        if (!item || !item.id) return;
        router.push({ path: `/article/${item.id}` })
    }

    onMounted(() => {
        getDetail() 
    });

    watch(
        () => route.params,
        () => {   
            articleId.value = route.params.id; 
            getDetail()
        },
        { immediate: true, deep: true }
    )

    


</script>

<style lang="scss" scoped>
    .article {
        width: 1200px;
        margin: 0 auto;
        padding: 40px 0;
        display: flex;
        margin-top: 10px;
        min-height: 50vh;

        &-content {
            flex: 1;
            margin-right: 24px;
            max-width: 800px;
        }
        
        &-html {
            margin: 24px;
            border-bottom: 1px solid #E5E7EB;

            :deep() {
                p {
                    min-height: 24px;
                }

                img {
                    max-width: 100%;
                }
            }
        }

        &-title {
            color: #000000;
            font-weight: 400;
            font-size: 30px;
            line-height: 38px;
            margin-bottom: 18px;
            padding: 0 24px;
        }

        &-time {
            color: #000000;
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            display: flex;
            align-items: center;
            padding: 0 24px;

            img {
                margin-right: 8px;
            }
        }

        &-footer {
            margin-top: 74px;
            padding-top: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #000000;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;

            &-left,
            &-right  {
                max-width: 45%;
            }

            &-right {
                text-align: right;

            }

            &-title {
                color: #999999;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
            }

            &-link {
                margin-top: 7px;
                color: #000000;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                height: 20px;
                cursor: pointer;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;

                &:hover {
                    text-decoration: underline;
                }
            }

        }
    }

    /* 响应式布局 */
@media (max-width: 768px) {
    .article {
        width: 100%;
        padding: 24px 12px;
        display: block;
        min-height: 70vh;
        margin-top: 0px;
        box-sizing: border-box;

        &-content {
            margin-right: 0;
            max-width: 100%;
        }

        &-title {
            font-size: 18px;
            line-height: 24px;
            margin-bottom: 8px;
        }

        &-time {
            font-size: 10px;
            line-height: 16px;
            display: flex;
            align-items: center;

            img {
                margin-right: 8px;
                width: 12px;
                height: 12px;
            }
        }

        &-footer {
            margin-top: 14px;
            padding-top: 14px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #000000;
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            width: 100%;
            margin-bottom: 24px;

            &-right {
                text-align: right;
            }

            &-title {
                color: #999999;
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
            }

            &-link {
                margin-top: 7px;
                color: #000000;
                font-weight: 400;
                font-size: 14px;
                line-height: 20px;
                cursor: pointer;

                &:hover {
                    text-decoration: underline;
                }
            }

        }

        .hot {
            margin: 0 auto;
        }
    }
}
</style>

